module.exports = __webpack_public_path__ + "img/img24.8698d4a0.png";